/* ============
 * Transformer
 * ============
 *
 * The base transformer.
 *
 * Transformers are used to transform the fetched data
 * to a more suitable format.
 * For instance, when the fetched data contains snake_cased values,
 * they will be camelCased.
 */
import _ from 'lodash'

export default class Transformer {
  /**
   * Method used to transform a fetched collection.
   *
   * @param {Array} items The items to be transformed.
   * @param {Array} pick Props to pick
   * @param {Array} omit Props to omit
   *
   * @returns {Array} The transformed items.
   */
  static fetchCollection (items, pick = null, omit = null) {
    return items.map(item => {
      const fetched = this.fetch(item)

      if (pick) {
        return _.pick(fetched, pick)
      } else if (omit) {
        return _.omit(fetched, omit)
      } else {
        return fetched
      }
    })
  }

  /**
   * Method used to transform a collection to be send.
   *
   * @param items The items to be transformed.
   *
   * @returns {Array} The transformed items.
   */
  static sendCollection (items) {
    return items.map(item => this.send(item))
  }

  /**
   * Property accessor
   * @param {Object} data ex.: {test:{val1: "some value"}}
   * @param {String} propertyPath ex.: "test.val1"
   * @return {any} property value // returns "some value"
   */
  static accessProperty (data, propertyPath) {
    const props = propertyPath.split('.')
    return props.reduce((prev, curr) => {
      if (typeof prev[curr] === 'undefined') {
        throw new Error(`Entry: ${JSON.stringify(data)}.\n Unknown property ${curr}, in property path ${propertyPath}`)
      }
      return prev[curr]
    }, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/Transformer.js